import { Component, Input, OnInit } from '@angular/core';
import { QuestionBase } from '@app/core/models/question/question-base';
import { FormGroup } from '@angular/forms';
import { formatStringToCurrency } from '@app/features/coverage/coverage';
import { getAmountMonthlyIncomeOfRegularSavings } from '@app/features/my-needs/my-needs';
import { SAVING_PERCENT_FOR_YEARLY_INCOME, MY_YEARLY_INCOME } from '@app/shared/slider/single-slider/constants';
import * as rxjsIsNumber from 'rxjs/util/isNumeric';
import { CalculatorPopupService } from '@app/core/calculator-popup.service';
declare var $;

@Component({
  selector: 'app-single-slider',
  templateUrl: './single-slider.component.html',
  styleUrls: ['./single-slider.component.css']
})
export class SingleSliderComponent implements OnInit {

  @Input() question: QuestionBase<any>;
  @Input() form: FormGroup;
  yearlyIncome: number; // this uses only for question type: savingPercentForYearlyIncome
  formatStringToCurrency: any;
  getAmountMonthlyIncomeOfRegularSavings: any;

  constructor(
    private calPopupService: CalculatorPopupService
  ) {

  }

  ngOnInit(): void {
    this.formatStringToCurrency = formatStringToCurrency;
    this.getAmountMonthlyIncomeOfRegularSavings = getAmountMonthlyIncomeOfRegularSavings;
    if (this.question.key === SAVING_PERCENT_FOR_YEARLY_INCOME) {
      this.yearlyIncome = this.form.get(MY_YEARLY_INCOME).value;
      // catch changes of yearlyIncome
      this.form.get(MY_YEARLY_INCOME).valueChanges.subscribe(val => this.yearlyIncome = val);
    }
  }

  onSlideChanged($event) {
    const value = $event.value;
    this.form.controls[this.question.key].setValue(value);
    if (rxjsIsNumber.isNumeric(value)) {
      this.form.controls[this.question.key].setValue(parseFloat(value.toString()));
    }

    this.form.updateValueAndValidity();
  }

  onSliding($event) {
    const value = $event.value;
    this.question.value = value;
  }

  onClickNumpad() {
    document.getElementById('numpad-body').innerHTML = '';
    this.calPopupService.addNumpadContentToModal(this.form, this.question, document.getElementById('numpad-body'));
    $('#modal-numpad').modal('toggle');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/slider/single-slider/single-slider.component.ts